import React, { memo, useCallback } from 'react'
import getUnicodeFlagIcon from 'country-flag-icons/unicode'
import {getCountryCallingCode} from 'react-phone-number-input';
import Select from 'forms/fields/SelectField';

export default (defaultCountry) => memo(({ options, value, onChange, disabled, iconComponent = () => {}, ...rest }) => {
    const onChange_ = useCallback((event) => {
        const value = event.target.value
        onChange(value === 'ZZ' ? undefined : value)
    }, [onChange])

    const defaultCountries = ['RU', 'UA', 'KZ', 'BY'];

    const preferredCountries = options.filter(o => defaultCountries.includes(o.value)).sort(function(a, b){
        return defaultCountries.indexOf(a.value) - defaultCountries.indexOf(b.value);
    });
    const restCountries = options.filter(o => !defaultCountries.includes(o.value) && o.value )

    const rOption = ({value, label}) => ({
        value,
        label: `${getUnicodeFlagIcon(value)}\u00a0\u00a0\u00a0${ label || 'Международный' } ${ value ? `+${ getCountryCallingCode(value) }` : '' }`
    })
    const rOptions = [
        ...preferredCountries.map(rOption),
        {value: 'separator', label: '', props: {disabled: true, className: 'separator'}},
        ...restCountries.map(rOption)
    ]

    return (
        <div className="PhoneInputCountry">
            <Select
                className={'PhoneInputCountrySelect'}
                {...rest}
                value={value || 'ZZ'}
                onChange={onChange_}
                options={rOptions}>
            </Select>
            <div className={ "PhoneInputCountryCallingCode" }>
                <div>{ `+${ getCountryCallingCode( value ? value : defaultCountry ) }` }</div>
            </div>
        </div>
    )
})
